module.exports = __webpack_public_path__ + "media/images/default/pages/about/clinic-new-2-daede9f89a37dc53f8bcadc7fd90da5c.jpeg";